/**
 * Collector admin api
 * Collector stats observe and manage
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class RequestsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param zombieId 
     * @param dateStart 
     * @param dateEnd 
     * @param method 
     * @param requestLike 
     * @param takeMs 
     * @param limit 
     * @param error 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public list(zombieId?: number, dateStart?: string, dateEnd?: string, method?: string, requestLike?: string, takeMs?: string, limit?: number, error?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public list(zombieId?: number, dateStart?: string, dateEnd?: string, method?: string, requestLike?: string, takeMs?: string, limit?: number, error?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public list(zombieId?: number, dateStart?: string, dateEnd?: string, method?: string, requestLike?: string, takeMs?: string, limit?: number, error?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public list(zombieId?: number, dateStart?: string, dateEnd?: string, method?: string, requestLike?: string, takeMs?: string, limit?: number, error?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (zombieId !== undefined && zombieId !== null) {
            queryParameters = queryParameters.set('zombieId', <any>zombieId);
        }
        if (dateStart !== undefined && dateStart !== null) {
            queryParameters = queryParameters.set('dateStart', <any>dateStart);
        }
        if (dateEnd !== undefined && dateEnd !== null) {
            queryParameters = queryParameters.set('dateEnd', <any>dateEnd);
        }
        if (method !== undefined && method !== null) {
            queryParameters = queryParameters.set('method', <any>method);
        }
        if (requestLike !== undefined && requestLike !== null) {
            queryParameters = queryParameters.set('requestLike', <any>requestLike);
        }
        if (takeMs !== undefined && takeMs !== null) {
            queryParameters = queryParameters.set('takeMs', <any>takeMs);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (error !== undefined && error !== null) {
            queryParameters = queryParameters.set('error', <any>error);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('get',`${this.basePath}/requests`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
